import { defaultAPIInstance } from "../index";

export const API = {
    getCategories(){
        const url = '/categories'
        return defaultAPIInstance.get(url)
    },

    getProductByCategory(id :number){
        const url = `/category/${id}/products`
        return defaultAPIInstance.get(url)
    },

    getProductById(id :number){
        const url = `/products/${id}`
        return defaultAPIInstance.get(url)
    },
}